(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'leaflet-directive',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy',
        'ui.calendar',
        'webcam'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('UsuarioSelecionarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_ROOT', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_ROOT, $compile)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.consultar();
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.consultar = function()
    {
      vm.consultarPromise = $http.get(APP_ROOT + "/usuario/usuarios")
      .then(function(response)
      {
        vm.registrosOriginal = response.data;
        vm.registros = response.data;          
        vm.filtrarPesquisa();
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
              {
                incluir = false;
              }
              else
              {
                incluir = true;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('EsqueciSenhaController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_ROOT', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_ROOT, $compile)
  {
    var vm = this;
    vm.registro = {};

    vm.init = function()
    {
    }

    vm.enviar = function()
    {
      if (vm.registro.login == null || vm.registro.login == '')
      {
        alert('Informe o seu e-mail de cadastro.');
        return;
      }

      vm.enviarPromise = $http.post(APP_ROOT + "/esquecisenha/reset", vm.registro).success(function(response){        
        toastr.info('Foi enviado um e-mail com instruções para a alteração da senha.', 'Alerta');
        $uibModalInstance.close();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
angular
.module('inspinia').factory("UsuarioService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                senha: pwd,
                origem: 'web'
            }
            return $http.post(APP_ROOT + "/token/userWeb", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresaName);
                    AuthService.setEmpid(response.data.empid);
                    AuthService.setRole(response.data.role);
                    AuthService.setFotoUser(response.data.fotoUser);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        },
        insert: function(usuario){
            return $http.post(APP_ROOT + "/usuario", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, usuario){
            usuario.ViewId = viewId;
            return $http.post(APP_ROOT + "/usuario/update", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        updatePassword: function(oldPassword, newPassword){
            usuario = {};
            usuario.oldPassword = oldPassword;
            usuario.newPassword = newPassword;
            return $http.post(APP_ROOT + "/usuario/updatePassword", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(usuario){
            return $http.post(APP_ROOT + "/usuario/remove", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_ROOT + "/usuario/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_ROOT + "/usuario")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getMenu: function (viewId) {
            return $http.get(APP_ROOT + "/auth/menu")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioPesquisaController', ['$scope', '$state', 'UsuarioService', 'toastr', 'PagerService',
      function($scope, $state, UsuarioService, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.usuarios.length, page);
      vm.items = vm.usuarios.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.pesquisar = function()
    {
      var usuariosPromise = UsuarioService.getAll();

      usuariosPromise.then(function(result) {  
        if (result.status)
        {
          vm.usuarios = result.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
        }
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarusuario');
    }

    vm.visualizar = function(usuario)
    {
      $state.go('index.consultarusuario', {obj: usuario});
    }

    vm.alterar = function(usuario)
    {
      $state.go('index.alterarusuario', {obj: usuario});
    }    

    vm.pesquisar();

  }]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioLoginController', ['$scope', '$state', 'UsuarioService', 'toastr', 'AuthService', 
      function($scope, $state, UsuarioService, toastr, AuthService)
  {
    var vm = this;

  }]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioCadastroController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
{
    var vm = this;

    vm.usuario = {};

    vm.incluir = function()
    {
      var usuarioPromise = UsuarioService.insert(vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário cadastrado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoSenhaController', ['$scope', '$state', 'toastr', '$http', 'APP_ROOT',
      function($scope, $state, toastr, $http, APP_ROOT)
  {
    var vm = this;

    vm.atualizar = function()
    {
      var request = {
        senhaAnterior: vm.oldPassword,
        novaSenha: vm.newPassword
      };

      vm.aprovarAberturaPromise = $http.post(APP_ROOT + "/usuario/alterarsenha", request).success(function(response){
        toastr.info('Senha atualizada com sucesso.', 'Alerta');   
        $state.go('index.main');          
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
  {
    var vm = this;

    vm.usuario = {};
    vm.usuarioParam = $state.params.obj;

    vm.consultar = function()
    {
      var usuarioConsultaPromise = UsuarioService.get(vm.usuarioParam.ViewId);

      usuarioConsultaPromise.then(function(result) {  
        vm.usuario = result;
      });
    }

    vm.alterar = function()
    {
      var usuarioPromise = UsuarioService.update(vm.usuarioParam.ViewId, vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.excluir = function()
    {
      var deleteUsuarioPromise = UsuarioService.delete(vm.usuarioParam);

      deleteUsuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário excluído com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.init = function()
    {
      if (vm.usuarioParam == null)
      {
        $state.go('index.pesquisarusuario');
      }
      else
      {
        vm.consultar();
      }
    }

    vm.init();

}]);

angular.module('inspinia')
    .factory('AuthService', AuthService);

function AuthService ($localStorage, $q) {
    return {
    getToken : function () {
        return $localStorage.tokenCli;
    },
    setToken: function (token) {
        $localStorage.tokenCli = token;
    },
    getUser : function () {
        return $localStorage.userCli;
    },
    setUser: function (user) {
        $localStorage.userCli = user;
    },
    getRole : function () {
        return $localStorage.roleCli;
    },
    setRole: function (role) {
        $localStorage.roleCli = role;
    },
    getMenu : function () {
        return $localStorage.menuCli;
    },
    setMenu: function (menu) {
        $localStorage.menuCli = menu;
    },
    getEmpresa : function () {
        return $localStorage.empresaCli;
    },
    setEmpresa: function (empresa) {
        $localStorage.empresaCli = empresa;
    },
    getEmpid : function () {
        return $localStorage.empid;
    },
    setEmpid: function (em) {
        $localStorage.empid = em;
    },
    getFotoUser : function () {
        return $localStorage.fotoUser;
    },
    setFotoUser: function (foto) {
        $localStorage.fotoUser = foto;
    },
    logout : function (data) {
        delete $localStorage.tokenCli;
        delete $localStorage.userCli;
        delete $localStorage.roleCli;
        delete $localStorage.empresaCli;
        delete $localStorage.empid;
        delete $localStorage.fotoUser;
        $q.when();
    }
    };
}
angular.module('inspinia')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
});

function AuthInterceptor ($location, AuthService, $q) {
    return {
    request: function(config) {
        config.headers = config.headers || {};

        if (!config.skipInterceptor && AuthService.getToken()) {
            config.headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }
        
        return config;
    },

    responseError: function(response) {
        if (response.status === 401 || response.status === 403) {
        $location.path('/login');
        }

        return $q.reject(response);
    }
    }
}
'use strict';

angular.module('inspinia')
  .controller('ExternoAlterarSenhaController', ['$scope', '$state', 'toastr', 'APP_ROOT', '$http',
      function($scope, $state, toastr, APP_ROOT, $http)
  {
    var vm = this;
    vm.registro = {};
    vm.key = $state.params.id;    

    vm.init = function()
    {
      
    }

    vm.enviar = function()
    {
      if (vm.registro.novaSenha == null || vm.registro.novaSenha == '')
      {
        toastr.error('Favor informar o campo Nova Senha.', 'ALERTA');
        return;
      }

      if (vm.registro.confirmarSenha == null || vm.registro.confirmarSenha == '')
      {
        toastr.error('Favor informar o campo Confirmar Nova Senha.', 'ALERTA');        
        return;
      }

      if (vm.registro.novaSenha != vm.registro.confirmarSenha)
      {
        toastr.error('Senhas não são iguais, favor confirmar novamente sua senha.', 'ALERTA');
        return;
      }

      vm.registro.id = vm.key;
      vm.enviarPromise = $http.post(APP_ROOT + "/recuperarsenha/alterar", vm.registro).success(function(response){        
        toastr.info('Senha alterada com sucesso.', 'Alerta');
        $state.go('login.autenticar');
        return response;
      }).error(function(error){
        toastr.error(error, 'ALERTA');
        return error;
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('MainController', ['$state', 'AuthService', 'UsuarioService', 'toastr', '$cookieStore', 'APP_ROOT', '$http', '$uibModal',
  function ($state, AuthService, UsuarioService, toastr, $cookieStore, APP_ROOT, $http, $uibModal) {

    var vm = this;
    vm.userName = AuthService.getUser();
    vm.empresaName = AuthService.getEmpresa();
    vm.menus = AuthService.getMenu();
    vm.role = AuthService.getRole();
    vm.fotoUser = AuthService.getFotoUser();
    vm.empid = AuthService.getEmpid();
    vm.usuario = {};     
    vm.default = '';    
    
    vm.restricaoSituacaoVenda = true;
    vm.restricaoCadastroProduto = true;

    vm.usuario = {};
    vm.usuario.Login = '';
    vm.usuario.Password = '';

    vm.init = function()
    {
      if ($cookieStore.get('lastLogin') != null)
      {
        vm.usuario.Login = $cookieStore.get('lastLogin');
      }
    }

    vm.login = function()
    {
      if (vm.usuario.Login == '')
      {
        return;
      }

      if (vm.usuario.Password == '')
      {
        return;
      }

      $cookieStore.put('lastLogin', vm.usuario.Login);
      
      vm.loginPromise = UsuarioService.login(vm.usuario.Login, vm.usuario.Password);

      vm.loginPromise.then(function(result) {  
        if(result.data.authenticated)
        {
            vm.default = result.data.default;

            vm.userName = AuthService.getUser();
            vm.empresaName = AuthService.getEmpresa();
            vm.role = AuthService.getRole();
            vm.fotoUser = AuthService.getFotoUser();
            vm.empid = AuthService.getEmpid();
            
            /*
            vm.menusPromise = UsuarioService.getMenu();

            vm.menusPromise.then(function(result2) {  
              vm.menus = result2;
              AuthService.setMenu(vm.menus);
              $state.go(vm.default);
            });
            */
            /*
            vm.restricaoProdutosPromise = $http.get(APP_ROOT + "/checkmodule/restricaoprodutoservico")
            .then(function(response)
            { 
              //alert('produtos: ' + response.data)
              vm.restricaoCadastroProduto = response.data;
            });

            vm.restricaoSituacaoVendaPromise = $http.get(APP_ROOT + "/checkmodule/restricaosituacaovenda")
            .then(function(response)
            { 
              vm.restricaoSituacaoVenda = response.data;
              //alert('situacao: ' + response.data)
            });
            */

            $state.go("index.main");
        }
        else
        {
          if (result.data.message == 'login_error_105')
          {
            result.data.message = 'Usuário e/ou senha inválidos.';
          } else if (result.data.message == 'login_error_104')
          {
            result.data.message = 'E-mail não cadastrado.';
          }

          toastr.error(result.data.message, 'Login');
        }
      });
    }

    vm.esqueciMinhaSenha = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/usuario/esqueci_senha/index.html',
        controller: 'EsqueciSenhaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'xs',
      }).result.then(function(data){
        vm.ticket.assunto = data;        
        vm.gerarCampos();
        //vm.listar();
      });
    }

    vm.init();

  }]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$http', 'APP_ROOT', 'HomeService', '$uibModal',
  function ($state, $scope, toastr, $http, APP_ROOT, HomeService, $uibModal) {

    var vm = this;
    vm.isAssinante = true;
    vm.ano = 2021;
    vm.anoReceitaCategoria = 2021;
    vm.anoDespesaCategoria = 2021;

    vm.init = function()
    {
      vm.checkAssinatura();      

      var data = new Date();
      //vm.mes = data.getMonth() + 1;
      vm.ano = data.getFullYear();
      vm.anoReceitaCategoria = vm.ano;
      vm.anoDespesaCategoria = vm.ano;

      vm.getIndicadores();
      vm.getReceitasDespesasChart();
      vm.loadReceitasCategorias();
      vm.loadDespesasCategorias();
    }

    vm.checkAssinatura = function()
    {      
      vm.registrosPromise = $http.get(APP_ROOT + "/pagamentoApp/checkAssinatura")
      .then(function(response)
      { 
        if (!response.data)
        {
          vm.alertaNaoAssinante();
        }
      });
    }

    vm.getIndicadores = function()
    {
      vm.indicadoresPromise = $http.get(APP_ROOT + "/home/indicadores")
      .then(function(response)
      {           
          vm.indicadores = response.data;
      });
    }

    function addCommas(nStr)
    {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? ',' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + '.' + '$2');
      }
      return x1 + x2;
    }

    vm.getReceitasDespesasChart = function()
    {
      vm.receitasDespesasChartPromise = $http.get(APP_ROOT + "/home/receitasDespesasChart/" + vm.ano)
      .then(function(response)
      { 
          var registros = response.data;
          
          vm.graficoMensalidade.labels = registros.meses;
          vm.graficoMensalidade.series = ['Receita', 'Despesa'];
          vm.graficoMensalidade.colors = ['#36A2EB', '#FF6384'];
          vm.graficoMensalidade.data = [            
            registros.receitas,
            registros.despesas,
          ];
      });
    }

    vm.graficoMensalidade = {
      labels: [],
      series: [],
      colors: [],
      data: []
    };
    vm.despesasCategoriaChart = {
      labels: [],
      series: [],
      colors: [],
      data: []
    };
    vm.receitasCategoriaChart = {
      labels: [],
      series: [],
      colors: [],
      data: []
    };
    
    vm.chartProgOptions = {
      legend: {
          display: true
      },
      plugins: {
        datalabels: {
          display: false
        },
        outlabels: {
          display: true
        }
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            //return label +  ': R$ ' + addCommas(datasetLabel.toString());
            return ' R$ ' + addCommas(datasetLabel.toString());
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            min: 0
          }
        }]
      },
    };

    vm.chartCategoriasOptions = {
      legend: {
          display: true
      },
      plugins: {
        datalabels: {     
          formatter: function(value, context) {
            return 'R$ ' + addCommas(value.toString());
          },
          color: 'black',
          labels: {
            title: {
                font: {
                    weight: 'bold'
                }
            },
            value: {
                color: 'black'
            }
          }
        }
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label +  ': R$ ' + addCommas(datasetLabel.toString());
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            min: 0
          }
        }]
      },
    };

    vm.loadReceitasCategorias = function()
    {
      vm.receitasCategoriasChartPromise = $http.get(APP_ROOT + "/home/receitasCategoriasChart/" + vm.anoReceitaCategoria)
      .then(function(response)
        { 
          var dados = response.data;

          vm.receitasCategoriaChart.labels = dados.categorias;
          vm.receitasCategoriaChart.series = dados.categorias;
          vm.receitasCategoriaChart.backgroundColor = [
            'rgba(255, 99, 132, 0.2)', 
            'rgba(255, 159, 64, 0.2)', 
            'rgba(255, 205, 86, 0.2)', 
            'rgb(54, 162, 235)', 
            'rgb(255, 99, 132)', 
            'rgb(255, 205, 86)', 
            'rgba(201, 203, 207, 0.2)'
          ];
          vm.receitasCategoriaChart.data = dados.valores;          
      });
    }

    vm.loadDespesasCategorias = function()
    {
      vm.despesasCategoriasChartPromise = $http.get(APP_ROOT + "/home/despesasCategoriasChart/" + vm.anoDespesaCategoria)
      .then(function(response)
        { 
          var dados = response.data;

          vm.despesasCategoriaChart.labels = dados.categorias;
          vm.despesasCategoriaChart.series = dados.categorias;
          vm.despesasCategoriaChart.backgroundColor = [
            'rgba(255, 99, 132, 0.2)', 
            'rgba(255, 159, 64, 0.2)', 
            'rgba(255, 205, 86, 0.2)', 
            'rgb(54, 162, 235)', 
            'rgb(255, 99, 132)', 
            'rgb(255, 205, 86)', 
            'rgba(201, 203, 207, 0.2)'
          ];
          vm.despesasCategoriaChart.data = dados.valores;          
      });
    }

    vm.alertaNaoAssinante = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/plano/alerta/index.html',
        controller: 'PlanoAlertaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',      
        size: 'md',
      }).result.then(function(data){
        
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
      var icon = angular.element(document.getElementById(icon));
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      var elm = angular.element(document.getElementById(box));
      elm.slideToggle(200);
    };

  }]);

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('login', {
        abstract: true,
        url: "/login",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })
      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Dashboard de Projetos' }
      })

      // Login
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      // Externo
      .state('ext', {
        abstract: true,
        url: "/ext",
        controller: 'ExternoAlterarSenhaController',
        controllerAs: 'alterarSenhaController',
        templateUrl: "app/reset_senha/index.html"
      })
      // Reset de senha
      .state('ext.alterarsenha', {
        url: "/updatepassword/:id",
        controller: 'ExternoAlterarSenhaController',
        controllerAs: 'alterarSenhaController',
        templateUrl: "app/reset_senha/index.html",
        params: {
          id: null
        }
      })

      // Financeiro - Receitas
      .state('index.financeiro_receitas', {
        url: "/financeiro_receitas",
        templateUrl: "app/financeiro/receita/index.html",
        controller: 'FinanceiroReceitaController',
        controllerAs: 'controller',        
      })
      .state('index.financeiro_despesas', {
        url: "/financeiro_despesas",
        templateUrl: "app/financeiro/despesa/index.html",
        controller: 'FinanceiroDespesaController',
        controllerAs: 'controller',        
      })


      // Cliente
      .state('index.cliente_pesquisar', {
        url: "/cliente_pesquisar",
        templateUrl: "app/cliente/pesquisar/index.html",
        controller: 'ClientePesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.cliente_cadastrar', {
        url: "/cliente_cadastrar/:viewId",
        templateUrl: "app/cliente/cadastrar/index.html",
        controller: 'ClienteCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.cliente_importar', {
        url: "/cliente_importar",
        templateUrl: "app/cliente/importar/index.html",
        controller: 'ClienteImportarController',
        controllerAs: 'controller'
      })

      // Fornecedor
      .state('index.fornecedor_pesquisar', {
        url: "/fornecedor_pesquisar",
        templateUrl: "app/fornecedor/pesquisar/index.html",
        controller: 'FornecedorPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.fornecedor_cadastrar', {
        url: "/fornecedor_cadastrar/:viewId",
        templateUrl: "app/fornecedor/cadastrar/index.html",
        controller: 'FornecedorCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })


      // Produto
      .state('index.produto_pesquisar', {
        url: "/produto_pesquisar",
        templateUrl: "app/produto/pesquisar/index.html",
        controller: 'ProdutoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.produto_cadastrar', {
        url: "/produto_cadastrar/:viewId",
        templateUrl: "app/produto/cadastrar/index.html",
        controller: 'ProdutoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Servico
      .state('index.servico_pesquisar', {
        url: "/servico_pesquisar",
        templateUrl: "app/servico/pesquisar/index.html",
        controller: 'ServicoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.servico_cadastrar', {
        url: "/servico_cadastrar/:viewId",
        templateUrl: "app/servico/cadastrar/index.html",
        controller: 'ServicoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Categoria - Receita
      .state('index.categoria_receita', {
        url: "/categoria_receita",
        templateUrl: "app/categoria/receita/index.html",
        controller: 'CategoriaReceitaController',
        controllerAs: 'controller',        
      })
      // Categoria - Despesa
      .state('index.categoria_despesa', {
        url: "/categoria_despesa",
        templateUrl: "app/categoria/despesa/index.html",
        controller: 'CategoriaDespesaController',
        controllerAs: 'controller',        
      })


      // Venda
      .state('index.pedidos', {
        url: "/venda_pesquisar/:tipo",
        templateUrl: "app/venda/pesquisar/index.html",
        controller: 'VendaPesquisarController',
        controllerAs: 'controller', 
        params: {
          tipo: null,
        }
      })
      .state('index.pedido_cadastrar_inicio', {
        url: "/pedido_cadastrar_inicio",
        templateUrl: "app/venda/cadastrar/inicio/index.html",
        controller: 'VendaCadastrarInicioController',
        controllerAs: 'controller',
      })
      .state('index.pedido_cadastrar', {
        url: "/pedido_cadastrar/:viewId",
        templateUrl: "app/venda/cadastrar/index.html",
        controller: 'VendaCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null
        }
      })
      .state('index.venda_imprimir', {
        url: "/venda_imprimir/:viewId",
        templateUrl: "app/venda/imprimir/index.html",
        controller: 'VendaImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // PDV
      .state('index.pdv_pesquisar', {
        url: "/pdv_pesquisar",
        templateUrl: "app/pdv/pesquisar/index.html",
        controller: 'PdvPesquisarController',
        controllerAs: 'controller', 
      })
      .state('index.pdv_cadastrar', {
        url: "/pdv_cadastrar",
        templateUrl: "app/pdv/cadastrar/index.html",
        controller: 'PdvCadastrarInicioController',
        controllerAs: 'controller',
      })

      // Orcamento
      .state('index.orcamento_pesquisar', {
        url: "/orcamento_pesquisar",
        templateUrl: "app/orcamento/pesquisar/index.html",
        controller: 'OrcamentoPesquisarController',
        controllerAs: 'controller', 
      })
      .state('index.orcamento_cadastrar', {
        url: "/orcamento_cadastrar",
        templateUrl: "app/orcamento/cadastrar/index.html",
        controller: 'OrcamentoCadastrarInicioController',
        controllerAs: 'controller',
      })



      /*
      // Pedido
      .state('index.pedido_pesquisar', {
        url: "/pedido_pesquisar",
        templateUrl: "app/pedido/pesquisar/index.html",
        controller: 'PedidoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.pedido_cadastrar', {
        url: "/pedido_cadastrar/:viewId",
        templateUrl: "app/pedido/cadastrar/index.html",
        controller: 'PedidoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.pedido_imprimir', {
        url: "/pedido_imprimir/:viewId",
        templateUrl: "app/pedido/imprimir/index.html",
        controller: 'PedidoImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      */


      

      // Agenda - Calendario
      .state('index.agenda_calendario', {
        url: "/agenda_calendario",
        templateUrl: "app/agenda/calendario/index.html",
        controller: 'AgendaCalendarioController',
        controllerAs: 'controller',        
      })
      /*
      // Venda
      .state('index.venda_pesquisar', {
        url: "/venda_pesquisar/:tipo",
        templateUrl: "app/venda/pesquisar/index.html",
        controller: 'VendaPesquisarController',
        controllerAs: 'controller', 
        params: {
          tipo: null,
        }
      })
      .state('index.venda_cadastrar', {
        url: "/venda_cadastrar/:viewId/:tipo",
        templateUrl: "app/venda/cadastrar/index.html",
        controller: 'VendaCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
          tipo: null
        }
      })
      .state('index.venda_imprimir', {
        url: "/venda_imprimir/:viewId",
        templateUrl: "app/venda/imprimir/index.html",
        controller: 'VendaImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })      
      */

      // Orcamento
      /*
      .state('index.orcamento_pesquisar', {
        url: "/orcamento_pesquisar",
        templateUrl: "app/orcamento/pesquisar/index.html",
        controller: 'OrcamentoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.orcamento_cadastrar', {
        url: "/orcamento_cadastrar/:viewId",
        templateUrl: "app/orcamento/cadastrar/index.html",
        controller: 'OrcamentoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      .state('index.orcamento_imprimir', {
        url: "/orcamento_imprimir/:viewId",
        templateUrl: "app/orcamento/imprimir/index.html",
        controller: 'OrcamentoImprimirController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })


      // Relatorio - Vendas
      .state('index.relatorio_vendas', {
        url: "/relatorio_vendas",
        templateUrl: "app/relatorio/vendas/index.html",
        controller: 'RelatorioVendasController',
        controllerAs: 'controller',
      })
      // Relatorio - Vendas Lucro
      .state('index.relatorio_vendas_lucro', {
        url: "/relatorio_vendas_lucro",
        templateUrl: "app/relatorio/venda_lucro/index.html",
        controller: 'RelatorioVendasLucroController',
        controllerAs: 'controller',
      })
      // Relatorio - Produtos Vendas
      .state('index.relatorio_produtos_vendas', {
        url: "/relatorio_produtos_vendas",
        templateUrl: "app/relatorio/produtos_vendas/index.html",
        controller: 'RelatorioProdutoVendasController',
        controllerAs: 'controller',
      })
      */

      /*
      // Objetivo
      .state('index.objetivo_pesquisar', {
        url: "/objetivo_pesquisar",
        templateUrl: "app/objetivo/pesquisar/index.html",
        controller: 'ObjetivoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.objetivo_cadastrar', {
        url: "/objetivo_cadastrar/:viewId",
        templateUrl: "app/objetivo/cadastrar/index.html",
        controller: 'ObjetivoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Projeto
      .state('index.projeto_pesquisar', {
        url: "/projeto_pesquisar",
        templateUrl: "app/projeto/pesquisar/index.html",
        controller: 'ProjetoPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.projeto_cadastrar', {
        url: "/projeto_cadastrar/:viewId",
        templateUrl: "app/projeto/cadastrar/index.html",
        controller: 'ProjetoCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })

      // Tarefa
      .state('index.tarefa_pesquisar', {
        url: "/tarefa_pesquisar",
        templateUrl: "app/tarefa/pesquisar/index.html",
        controller: 'TarefaPesquisarController',
        controllerAs: 'controller',        
      })
      .state('index.tarefa_cadastrar', {
        url: "/tarefa_cadastrar/:viewId",
        templateUrl: "app/tarefa/cadastrar/index.html",
        controller: 'TarefaCadastrarController',
        controllerAs: 'controller',
        params: {
          viewId: null,
        }
      })
      */

      /*
      // Atendimento
      .state('index.pesquisaratendimento', {
        url: "/pesquisaratendimento",
        templateUrl: "app/atendimento/pesquisar/index.html",
        controller: 'AtendimentoPesquisaController',
        controllerAs: 'controller',
        data: { pageTitle: 'Pesquisar atendimentos' }
      })
      .state('index.cadastraratendimento', {
        url: "/cadastraratendimento",
        params: {
          contato: null,
          atendimento: null
        },
        templateUrl: "app/atendimento/cadastrar/index.html",
        controller: 'AtendimentoCadastroController',
        controllerAs: 'controller',
        data: { pageTitle: 'Cadastrar atendimento' }
      })
      .state('index.consultaratendimento', {
        url: "/consultaratendimento",
        params: {
          obj: null
        },
        templateUrl: "app/atendimento/consultar.html",
        controller: 'AtendimentoConsultaController',
        controllerAs: 'atendimentoController',
        data: { pageTitle: 'Consultar atendimento' }
      })

      // Agenda
      .state('index.agenda_consultar', {
        url: "/agenda_consultar",
        templateUrl: "app/agenda/consultar/index.html",
        controller: 'AgendaConsultarController',
        controllerAs: 'controller'
      })
      .state('index.agenda_cadastrar', {
        url: "/agenda_cadastrar",
        templateUrl: "app/agenda/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Mapas
      .state('index.mapa_contatos_geral', {
        url: "/mapa_contatos_geral",
        templateUrl: "app/mapa/contato/index.html",
        controller: 'MapaContatosController',
        controllerAs: 'mapaController'
      })


      // Lideranca
      .state('index.lideranca_pesquisar', {
        url: "/lideranca_pesquisar",
        templateUrl: "app/lideranca/pesquisar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      .state('index.lideranca_cadastrar', {
        url: "/lideranca_cadastrar",
        templateUrl: "app/lideranca/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Emenda
      .state('index.emenda_pesquisar', {
        url: "/emenda_pesquisar",
        templateUrl: "app/emenda/pesquisar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      .state('index.emenda_cadastrar', {
        url: "/emenda_cadastrar",
        templateUrl: "app/emenda/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      */

      // Documentos
      .state('index.documento_pesquisar', {
        url: "/documento_pesquisar",
        templateUrl: "app/documento/pesquisar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })
      .state('index.documento_cadastrar', {
        url: "/documento_cadastrar",
        templateUrl: "app/documento/cadastrar/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })

      // Relatorio
      .state('index.relatorio_teste', {
        url: "/relatorio_teste",
        templateUrl: "app/relatorio/teste/index.html",
        controller: 'MockController',
        controllerAs: 'controller',
      })


      // Usuarios
      .state('index.pesquisarusuario', {
        url: "/pesquisarusuario",
        templateUrl: "app/usuario/pesquisar.html",
        controller: 'UsuarioPesquisaController',
        controllerAs: 'usuarioPesquisa',
        data: { pageTitle: 'Pesquisar usuários' }
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
        data: { pageTitle: 'Cadastrar Usuário' }
      })
      .state('index.alterarusuario', {
        url: "/alterarusuario",
        templateUrl: "app/usuario/alterar.html",
        controller: 'UsuarioAlteracaoController',
        controllerAs: 'usuarioAlteracao',
        params: {
          obj: null
        },
        data: { pageTitle: 'Editar Usuário' }
      })
      .state('index.alterarsenha', {
        url: "/alterarsenha",
        templateUrl: "app/usuario/alterarsenha.html",
        controller: 'UsuarioAlteracaoSenhaController',
        controllerAs: 'controller',
        data: { pageTitle: 'Alterar Senha' }
      })

      // Index
      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })

      // Tests
      .state('index.minor', {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: 'Example view' }
      });

      $urlRouterProvider.otherwise('/login/autenticar');
  }

})();

angular
.module('inspinia')
.factory('PagerService', PagerService)

//.constant('APP_ROOT', "https://localhost:5001/api");
//.constant('APP_ROOT', "http://localhost/quoteapp");

// Testes
//.constant('APP_ROOT', "https://contasapp.azurewebsites.net/api");
//.constant('APP_ROOT', "https://contasapp.b2desk.com/api");

// Producao
.constant('APP_ROOT', "https://apiquoteapp.azurewebsites.net");

function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 20;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular
.module('inspinia')
.factory('Excel',function($window){
    var uri='data:application/vnd.ms-excel;base64,',
        template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
        format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};
    return {
        tableToExcel:function(tableId,worksheetName){
            var table=$(tableId),
                ctx={worksheet:worksheetName,table:table.html()},
                href=uri+base64(format(template,ctx));
            return href;
        }
    };
});

angular.module('inspinia').value('cgBusyDefaults',{
    message:'Carregando222',
    templateUrl: 'app/components/common/loading.html'
  });

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
.config( [
    '$compileProvider',
    function( $compileProvider )
    {   
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
        // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
    }
]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}

/* angular-datepicker
angular.module('inspinia')
.config(function ($provide)
{
    $provide.decorator('mFormatFilter', function ()
    {
        return function newFilter(m, format, tz)
        {
            if (!(moment.isMoment(m))) {
                return '';
            }
            return tz ? moment.tz(m, tz).format(format) : m.format(format);
        };
    });
});
*/
'use strict';

angular.module('inspinia').filter('cut', function () {
    return function (value, wordwise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
            var lastspace = value.lastIndexOf(' ');
            if (lastspace !== -1) {
              //Also remove . and , so its gives a cleaner result.
              if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                lastspace = lastspace - 1;
              }
              value = value.substr(0, lastspace);
            }
        }

        return value + (tail || ' …');
    };
});

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
.directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })

    .directive('moneyMask', ['$timeout', 'moneyMaskService', function($timeout, moneyMaskService) {
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ctrl) {
              var execute = function () {
                  scope.$apply(function () {
                      ctrl.$setViewValue(moneyMaskService.fromStringToMoney(ctrl.$modelValue));
                      ctrl.$render();
                  });
              };
              element.bind('keyup', function () {
                  execute();
              });
              
              $timeout(function () { 
                  execute();
              }, 500);
           }
        };
     }])
     .factory("moneyMaskService", [ "$filter", function ($filter) {
        var _otherCharacters = /[^0-9]/g;
        var _zeros = /^0+/;
        
        var _fromStringToMoney = function (string) {
            return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2)).replaceAll('R$','');
        };
        
        var _fromStringToNumber = function (string) {
            if (!string) return 0;
            return string.toString().replace(_otherCharacters, '').replace(_zeros, '') || 0;
        }
        
        return {
            fromStringToMoney: _fromStringToMoney
        };
    }])
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-black2" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });


/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\" ng-if=\"!home.isAssinante\"><div class=\"col-lg-12\"><div class=\"alert alert-danger\"><b>Atenção:</b> Este portal é exclusivo para assinantes do aplicativo.</div></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><h5><b>Receitas</b></h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.indicadores.receitas | number:2}}</h1><small>neste mês</small></div></div></div><div class=\"col-lg-4\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><h5><b>Despesas</b></h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.indicadores.despesas | number:2}}</h1><small>neste mês</small></div></div></div><div class=\"col-lg-4\"><div class=\"ibox float-e-margins\" cg-busy=\"home.indicadoresPromise\"><div class=\"ibox-title\"><h5><b>Saldo</b></h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\" ng-class=\"home.indicadores.projecao < 0 ? \'text-danger\' : \'\'\">{{home.indicadores.projecao | number:2}}</h1><small>neste mês</small></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 15px;\" cg-busy=\"home.receitasDespesasChartPromise\"><div class=\"ibox-title bg-black2\" ng-click=\"home.showhide(\'iconBoxMensalidade\', \'boxMensalidade\')\"><h5><i class=\"fa fa-area-chart\"></i> Receitas x Despesas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxMensalidade\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxMensalidade\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-3\"><select class=\"form-control\" ng-model=\"home.ano\" ng-change=\"home.getReceitasDespesasChart()\"><option ng-value=\"2024\">2024</option><option ng-value=\"2023\">2023</option><option ng-value=\"2022\">2022</option><option ng-value=\"2021\">2021</option><option ng-value=\"2020\">2020</option><option ng-value=\"2019\">2019</option></select></div></div><div class=\"row\"><div class=\"col-lg-12\"><canvas class=\"chart chart-bar\" height=\"100\" chart-colors=\"home.graficoMensalidade.colors\" chart-data=\"home.graficoMensalidade.data\" chart-labels=\"home.graficoMensalidade.labels\" chart-series=\"home.graficoMensalidade.series\" chart-click=\"home.graficoMensalidade.onClick\" chart-options=\"home.chartProgOptions\"></canvas></div></div></div></div></div></div><div class=\"row\"></div></div>");
$templateCache.put("app/usuario/alterar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telegram</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.TelegramUser\" placeholder=\"Usuário do Telegram\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioAlteracao.alterar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/alterarsenha.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2 style=\"font-weight: 400;\">Senha</h2></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-8\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-black2\"><h5>Formulário</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Senha anterior</label><div class=\"col-lg-8\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.oldPassword\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Nova senha</label><div class=\"col-lg-8\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.newPassword\" class=\"form-control\"></div></div><div class=\"form-group\" style=\"margin-bottom: 0px;\"><div class=\"col-lg-11\" style=\"text-align: right\"><button class=\"btn btn-md btn-black2\" style=\"min-width: 180px;\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/usuario/autenticar.html","");
$templateCache.put("app/usuario/cadastrar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Password\" placeholder=\"Senha\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioCadastro.incluir()\">SALVAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/pesquisar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"usuarioPesquisa.incluir()\">NOVO USUÁRIO</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Resultado</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Nome</th><th style=\"width: 30%\">Login</th><th style=\"width: 30%\">E-mail</th></tr></thead><tbody><tr ng:repeat=\"p in usuarioPesquisa.items\"><td>{{p.nome}}</td><td>{{p.login}}</td><td>{{p.Email}}</td><td style=\"text-align: center;\"><a ng-click=\"usuarioPesquisa.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"usuarioPesquisa.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in usuarioPesquisa.pager.pages\" ng-class=\"{active:usuarioPesquisa.pager.currentPage === page}\"><a ng-click=\"usuarioPesquisa.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/reset_senha/index.html","<style>\r\n    body\r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 15px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-content\" style=\"padding: 0px; padding-bottom: 5px; padding-top: 10px; padding-left: 20px;\"><h1 style=\"font-size: 20px; font-weight: 500; font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen, Ubuntu, Cantarell, \'Open Sans\', \'Helvetica Neue\', sans-serif;\"><table style=\"padding: 0;\"><tr><td><div style=\"height: 10px\"></div><span style=\"font-size: 16px;\">Recuperação de Senha</span></td></tr></table></h1></div></div></div></div></div></div><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-ticket\"></i> Cadastre uma nova senha</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nova Senha <span class=\"red\">*</span></label> <input type=\"password\" maxlength=\"20\" ng-model=\"alterarSenhaController.registro.novaSenha\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Confirmar Nova Senha <span class=\"red\">*</span></label> <input type=\"password\" maxlength=\"20\" ng-model=\"alterarSenhaController.registro.confirmarSenha\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"alterarSenhaController.enviar()\"><i class=\"fa fa-arrow-right\"></i> Alterar Senha</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">LynkoApp v1.0.0</div><div><strong>Copyright</strong> &copy; 2021</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img ng-if=\"main.fotoUser != \'\'\" alt=\"image\" width=\"100px\" class=\"img-circle\" style=\"border: 4px solid white;\" src=\"{{main.fotoUser}}\"> <img ng-if=\"main.fotoUser == \'\'\" alt=\"image\" width=\"100px\" class=\"img-circle\" src=\"assets\\images\\icons\\icon_rb.png\"> <span class=\"block m-t\"><strong class=\"font-bold\" style=\"color: white;\">{{main.userName}}</strong></span> <span class=\"text-muted text-xs block\">{{main.empresaName}}</span></div></div><div class=\"logo-element\">LY</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tags\"></i> <span class=\"nav-label\">Pedidos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.pedido_cadastrar_inicio\">Novo</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.pedidos\">Pesquisa</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-money\"></i> <span class=\"nav-label\">Vendas</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.pdv_cadastrar\">Nova Venda</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.pdv_pesquisar\">Pesquisa</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empid < 1500\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-file-text-o\"></i> <span class=\"nav-label\">Orçamentos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.orcamento_cadastrar\">Novo</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.orcamento_pesquisar\">Pesquisa</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-upload\"></i> <span class=\"nav-label\">Receitas</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.financeiro_receitas\">Pesquisa</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-download\"></i> <span class=\"nav-label\">Despesas</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.financeiro_despesas\">Pesquisa</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-edit\"></i> <span class=\"nav-label\">Cadastros</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cliente_pesquisar\">Clientes</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.produto_pesquisar\">Produtos</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.servico_pesquisar\">Serviços</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.fornecedor_pesquisar\">Fornecedores</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Minha Conta</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.alterarsenha\">Alterar Senha</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login.autenticar\"><i class=\"fa fa-sign-out\"></i> Sair da Conta</a></li></ul></nav></div>");
$templateCache.put("app/usuario/esqueci_senha/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Esqueceu a sua senha?</h5><small class=\"font-bold\">Informe seu e-mail de cadastro para alteração de senha.</small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Informe o seu e-mail cadastrado</label> <input type=\"email\" maxlength=\"100\" ng-model=\"controller.registro.login\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.enviarPromise\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.enviar()\"><i class=\"fa fa-arrow-right\"></i> Enviar</button></div>");
$templateCache.put("app/usuario/selecionar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Cliente</h5></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar cliente:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.nome}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-blue2 btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");}]);